<template>
    <DsModal
        dialog
        :is-open="isOpen"
        @close="$emit('close')"
    >
        <div class="archive-warning-modal">
            <h5 class="modalTitle">
                {{ $t('campaignsPage.archiveWarningModal.title') }}
            </h5>
            <h6 class="stringPadding">
                {{ $t('campaignsPage.archiveWarningModal.subTitle') }}
            </h6>

            <section class="campaigns-list">
                <li
                    v-for="campaign in campaignsInBundles"
                    :key="campaign"
                    class="stringPadding"
                >
                    {{ campaign }}
                </li>
            </section>
            <div class="buttons">
                <DsTextButton @click="$emit('close')">
                    {{ $t('campaignsPage.archiveWarningModal.cancel') }}
                </DsTextButton>

                <DsFilledButton @click="archiveCampaigns">
                    {{ $t('campaignsPage.archiveWarningModal.action') }}
                </DsFilledButton>
            </div>
        </div>
    </DsModal>
</template>

<script>

export default {
    props: {
        campaignsInBundles: Array,
        isOpen: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        archiveCampaigns() {
            this.$emit('archive');
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .archive-warning-modal {
        display: flex;
        flex-direction: column;
    }
    .modalTitle {
        padding: 0 0 $spacing-200 0;
    }

    .stringPadding {
        padding: 0 0 $spacing-100 0;
    }

    .campaigns-list {
        max-height: px-to-rem(250px);
        overflow-y: scroll;
        padding-bottom: $spacing-200;
    }

    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

</style>
